/**
 *  @fileOverview Share module
 *
 *  @author Andras Muk <andras.muk@possible.com>
 */

class Share {
  init() {
    this.initDOMElements();
    if (this.share !== null) {
      this.initBindings();
    }
  }

  initDOMElements() {
    this.share = document.body.querySelector('[data-share]');
    if (this.share !== null) {
      this.shareButton = this.share.querySelector('[data-share-open]');
      this.copyButton = this.share.querySelector('[data-share-copy]');
    }
  }

  initBindings() {
    this.shareButton.addEventListener('keyup', (e) => {
      this.toggleShare(this.share, e);
    });
    this.copyButton.addEventListener('click', () => {
      this.copyToClipboard();
    });
    this.copyButton.addEventListener('keyup', (e) => {
      if (e.keyCode === 13) {
        this.copyToClipboard();
      }
    });
  }

  copyToClipboard() {
    const tempElement = document.createElement('input');
    tempElement.setAttribute('id', 'tempInput');
    tempElement.setAttribute('value', window.location.href);
    document.body.appendChild(tempElement);
    tempElement.select();
    document.execCommand('copy');
    document.body.removeChild(tempElement);
  }

  toggleShare(target, event) {
    if (event.keyCode === 13) {
      if (target.classList.contains('share--active')) {
        target.classList.remove('share--active');
      } else {
        target.classList.add('share--active');
      }
    }
  }
}

export const share = new Share();



// WEBPACK FOOTER //
// ./src/js/modules/share.js